import React, { useState } from "react";
import Layout from "./Layout";
import LinkedGroup from "./LinkedGroup";
import Locations from "./Locations";
import Profile from "./Profile";
import Payment from "./Payment";
import Password from "./Password";
import Reservations from "./Reservations";
import ResSummary from "@components/ResSummary/Page";

export default function ProfileHome() {
  const [currentFrame, setCurrentFrame] = useState("profile");

  function pageChange(page: be.ProfilePage) {
    setCurrentFrame(page);
  }
  let CurrentComp: (...args: any) => JSX.Element | null = Profile,
    maxWidthClass = "max-w-4xl",
    compProps: Record<string, any> = {};
  switch (currentFrame) {
    case "profile":
      CurrentComp = Profile;
      break;
    case "locations":
      CurrentComp = Locations;
      break;
    case "linkedGroup":
      CurrentComp = LinkedGroup;
      break;
    case "payment":
      CurrentComp = Payment;
      maxWidthClass = "max-w-full";
      break;
    case "password":
      CurrentComp = Password;
      break;
    case "reservations":
      CurrentComp = Reservations;
      compProps.onPageChange = pageChange;
      maxWidthClass = "max-w-full";
      break;
    case "res_summary":
      CurrentComp = ResSummary;
      maxWidthClass = "max-w-full";
      compProps = {
        className: "mt-10",
        flags: { keepUserLoggedIn: true },
        onBack: () => pageChange("reservations"),
        showBack: true,
        showLogout: false,
      };
      break;
  }

  return (
    <Layout maxWidthClass={maxWidthClass} onPageChange={pageChange}>
      <CurrentComp {...compProps} />
    </Layout>
  );
}
